<template>
  <div class="period-component" v-if="data">
    <div class="bg-container">
      <img
        class="bg"
        src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-01/4451e2f4f5779aa22a20c3d7e075c406_wh=1404_128.png"
        alt=""
      />
      <div class="bg-white"></div>
    </div>
    <div class="period-title">
      <img
        class="period-image"
        src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-01/4fc910cdc9de03a503ac3541c8ffbe2d_wh=297_87.png"
        alt=""
      />
      <div>该时段上课会员100%得实物奖品</div>
    </div>
    <div class="btn-container">
      <div
        class="time-container"
        v-if="data.data.study_times_info.is_show_easter_egg_pub_time"
      >
        <div class="time-list">
          <div
            class="time-item"
            v-for="(item, index) in data.data.study_times_info.times_section"
            :key="index"
            >{{ item.start_section }}-{{
              item.start_section | filtersTime
            }}</div
          >
        </div>
        <div class="total"
          >共有{{
            data.data.study_times_info.user_total
          }}位健萌er上课打卡，获得奖品</div
        >
      </div>
      <div class="btn" v-else>
        <img
          class="clock"
          src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-01/06c55651dd9559aa387a3f987b9e80ea_wh=216_210.png"
          alt=""
        />
        <span
          >{{ tomorrow }}
          {{ data.data.act_info.easter_egg_pub_time | filterHours }}后公布</span
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  components: {},
  filters: {
    filterHours(str) {
      return str.slice(0, 5)
    },
    filtersTime(str) {
      let now = new Date()
      now.setHours(parseInt(str.slice(0, 2)) + 1)
      let hour = now.getHours()
      return (hour <= 9 ? '0' + hour : hour) + str.slice(2)
    }
  },
  computed: {
    tomorrow() {
      if (this.data) {
        return this.getTomorrowDate(this.data.date)
      } else {
        return ''
      }
    },
    totalPerson() {
      if (this.data) {
        let num = 0
        this.data.data.study_times_info.map((item) => {
          num += item.user_total || 0
        })
        return num
      } else {
        return 0
      }
    }
  },
  data() {
    return {}
  },
  created() {},
  methods: {
    getTomorrowDate(dateStr) {
      const date = new Date(dateStr)
      date.setDate(date.getDate() + 1)

      const month = date.getMonth() + 1
      const day = date.getDate()

      return `${month}月${day}日`
    }
  }
}
</script>
<style lang="scss" scoped>
.period-component {
  padding: 15px 14px 6px;
  position: relative;
  z-index: 0;
  box-sizing: border-box;
  height: 187px;
  display: flex;
  align-items: stretch;
  flex-direction: column;
  .bg-container {
    position: absolute;
    left: 0;
    top: -1px;
    width: 100%;
    height: 100%;
    z-index: -1;
    display: flex;
    flex-direction: column;
    .bg {
      width: 100%;
    }
    .bg-white {
      margin-top: -1px;
      border-radius: 0px 0px 8px 8px;
      width: 100%;
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;
      background: linear-gradient(
        350deg,
        #ffe9d2 0px,
        rgb(255, 253, 250) 152px
      );
    }
  }

  .period-title {
    display: flex;
    align-items: center;
    font-family: PingFangSC, PingFang SC;
    font-size: 10px;
    color: rgba(0, 0, 0, 0.6);
    line-height: 10px;
    .period-image {
      width: 99px;
      height: 29px;
      object-fit: contain;
      margin-right: 6px;
    }
  }
  .btn-container {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .btn {
    position: relative;
    margin: 0 auto;
    width: 311px;
    height: 70px;
    background: linear-gradient(314deg, #ff6e1f 0%, #f53e48 100%);
    opacity: 0.8;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: MiSans, MiSans;
    font-weight: bold;
    font-size: 22px;
    color: #ffffff;
    border-radius: 8px;
    .clock {
      width: 94px;
      height: 70px;
      object-fit: contain;
      position: absolute;
      left: -11px;
      bottom: 0;
    }
  }
  .time-container {
    width: 311px;
    height: 82px;
    border: 1px solid rgba(217, 118, 118, 0.6);
    border-radius: 4px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    .time-list {
      font-family: DIN;
      font-weight: bold;
      font-size: 20px;
      color: #f31b27;
      line-height: 26px;
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      .time-item {
        position: relative;
        padding: 0px 11px 0px 14px;
      }
      .time-item::before {
        content: '';
        position: absolute;
        right: 0;
        top: 50%;
        transform: translate(0%, -50%);
        width: 1px;
        height: 14px;
        background-color: rgba(243, 27, 39, 0.3);
      }
      .time-item:last-child::before {
        display: none;
      }
    }
    .total {
      font-weight: bold;
      font-size: 13px;
      color: rgba(0, 0, 0, 0.8);
      line-height: 18px;
    }
  }
}
</style>
